let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k74GO")).then(() => parcelRequire('3cx6q'));